// funciones para sms.
// eslint-disable-next-line no-unused-vars
import * as FxLog from './FxLog';
import * as FxFetch from './FxFetch';
import { getStoreValue } from "../gx/GxStore";

export const getCertEmployee = async () => {
  let inEmployee = getStoreValue('StoreSession', 'inEmployee');

  if (!inEmployee) {
    // no hay empleado de sesión
    return { error: 'rv_no_session_employee' };
  }

  let record = {};
  record['inEmployee'] = inEmployee;
  return Promise.all([FxFetch.doJsonX('general/get_cert_employee', record)]).then((result) => {
    if (result[0]) {
      //FxLog.infox('FxCertificate.getCert', '...result[0]:', result[0]);
      let base64File = result[0].obCertFile;
      let password = result[0].txCertPwd;
      if (base64File) {
        return { 
          base64KeyStore: base64File, 
          pin: password,
        };
      } else {
        // el empleado no tiene Certificado
        return { error: 'rv_no_certificate_employee' };
      }
    }
  });
}
